import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Remove token from localStorage and cookies
    localStorage.removeItem('token');
    Cookies.remove('token'); // Clear token from cookies
    
    // Redirect to the login page
    navigate('/login');
  };

  return (
    <button className="btn btn-outline-danger" onClick={handleLogout}>
      Logout
    </button>
  );
};

export default LogoutButton;
